module.exports = __webpack_public_path__ + "img/rad-conv-Sala-Standard-1.55e9c439.png";